import { makeActionCreator } from '../../../utilities'
import { InitialAssessmentConstants } from './initialAssessment.constants'

export const setSelectedOption = makeActionCreator(InitialAssessmentConstants.SET_SELECTED_OPTION, 'selectedOption')
export const setPrNabcDefaults = makeActionCreator(InitialAssessmentConstants.SET_PR_NABC_DEFAULTS, '__areDefaultsSet')
